
import { useCallback } from "react";
import { LinkCountsData } from "./useLinkCountsApi";

/**
 * Hook to process follow links data into link counts
 */
export const useProcessLinkCounts = () => {
  /**
   * Process follow links into counts per account
   */
  const processLinkCounts = useCallback((
    followLinks: { account_id: string; used: boolean; capacity: number; num_used: number; }[] | null,
    accountIds: string[],
    existingCounts: LinkCountsData
  ): LinkCountsData => {
    // Create a copy of the existing counts
    const processedCounts: LinkCountsData = {...existingCounts};
    
    // Initialize counts for accounts being processed
    accountIds.forEach(id => {
      processedCounts[id] = { totalLinks: 0, usedLinks: 0 };
    });
    
    // Count the links
    if (followLinks && followLinks.length > 0) {
      followLinks.forEach(link => {
        console.log("Processing link:", link);
        const accountId = link.account_id;
        
        // Increment total count by capacity
        processedCounts[accountId].totalLinks += link.capacity;
        
        // Increment used links count by actual usage
        processedCounts[accountId].usedLinks += link.num_used;
      });
    }
    
    return processedCounts;
  }, []);
  
  /**
   * Update count after verification
   */
  const updateVerifiedCount = useCallback((
    accountId: string,
    verifiedCount: number | null,
    counts: LinkCountsData
  ): LinkCountsData => {
    // Create a copy of the counts
    const updatedCounts = {...counts};
    
    if (verifiedCount !== null && 
        updatedCounts[accountId] && 
        updatedCounts[accountId].totalLinks !== verifiedCount) {
      console.warn(`Count discrepancy for account ${accountId}: ` +
        `calculated ${updatedCounts[accountId].totalLinks} but total query shows ${verifiedCount}`);
      
      // Fix the discrepancy
      updatedCounts[accountId].totalLinks = verifiedCount;
    }
    
    return updatedCounts;
  }, []);
  
  return {
    processLinkCounts,
    updateVerifiedCount
  };
};
